export const ACCESS_TOKEN_COOKIE = "access_token";
export const REFRESH_TOKEN_COOKIE = "refresh_token";
export const WELCOME_MODAL_CASE = "welcomeModalCase";
